import React, { useEffect } from 'react';
import { useThemeStore } from 'shared-lib';

export function BackgroundProvider({ children }: { children: React.ReactNode }) {
    const { theme } = useThemeStore();

    useEffect(() => {
        if (theme === 'dark') {
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
        }
    }, [theme]);

    return <>{children}</>;
}
